var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgenCoIconWindmillRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419.5 425.2",
    style: {
      enableBackground: "new 0 0 419.5 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0windmill{fill:#145459;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0windmill",
    d: "M418.4,402.8l-67.7-178.2c-7.8-20.5-31.1-30.3-51.2-21.6l-11.1,4.8c-8.6,3.7-17.6-4.3-14.9-13.2l52.1-173.3 C330.8,4,308.5-7.8,297.1,6.1L176.4,153.8c-13.9,17-10.7,42.1,6.9,55.1l9.7,7.2c7.5,5.6,5.1,17.3-4,19.5L12.7,277.1 c-17.5,4.1-16.7,29.4,1.1,32.2L202.2,340c21.6,3.5,41.8-11.7,44.3-33.5l1.4-12c1.1-9.3,12.5-13,18.9-6.3L391,419.9 C403.3,433,424.8,419.6,418.4,402.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenCoIconWindmillRgb);
export default __webpack_public_path__ + "static/media/ArgenCo_icon_windmill_rgb.c354cc754d961ae9044a6aa987ab76c3.svg";
export { ForwardRef as ReactComponent };